import React, { useEffect, useState } from 'react';
import { getUserInfo } from 'js/library/utils/helpers';
import { toast } from 'react-toastify';

// Components
import { PageStructure } from 'js/components/TriiboComponents/PageStructure/PageStructure';
import { SearchBarWithButton } from 'js/components/TriiboComponents/SearchBarWithButton/SearchBarWithButton';
import { TableQuotes } from './TableQuotes';

// Apis
import { getBalance_v1 } from 'js/library/utils/API/Points/getBalance_v1';
import { getByPartnerIdOrEstablishmentId } from 'js/library/utils/API/getByPartnerIdOrEstablishmentId';
import { getSeuClube } from 'js/library/utils/API/seuClube';
import { CircularProgress } from '@mui/material';

export function MenageMessages() {
  const contratPrefix = '@contrato-triibo.com.br';
  const partnerIdClube = localStorage.getItem('partnerIdClube');
  const userInfo = getUserInfo();

  const { pathname } = document.location;
  const splitUrl = pathname.split('/');
  const clubeId = splitUrl.pop();

  const [dataQuotes, setDataQuotes] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [reload, setReload] = useState(false);
  const [loadingPoints, setLoadingPoints] = useState(true);
  const [userPoints, setUserPoints] = useState(0);

  useEffect(() => {
    getByPartnerIdOrEstablishmentId(partnerIdClube)
      .then((result) => setDataQuotes(Object.values(result)))
      .catch((error) => {
        if (error?.includes('Não foi possível encontrar a mensagem de comunicação de id')) {
          toast.warning('Ainda não existem orçamentos de mensagens criadas.');
        } else {
          toast.error(error);
        }
        console.error('Error fetching data =>', error);
      })
      .finally(() => {
        setLoadingTable(false);
      });
  }, [partnerIdClube, reload]);

  useEffect(() => {
    (async function fetchBalance() {
      const { uId } = userInfo || {};
      const { contractId } = await getSeuClube(clubeId);
      const { balance } = await getBalance_v1(uId, `${contractId + contratPrefix}`);
      setLoadingPoints(false);

      if (!balance || !balance.consolidateBalance) return;

      setUserPoints(balance.consolidateBalance.total);
    })();
  }, []);

  return (
    <PageStructure title="Gerenciar mensagens">
      <SearchBarWithButton
        buttonLabel="Nova cotação de mensangem"
        urlExtension="nova-comunicacao"
        userPoints={userPoints}
        searchDisabled
      />
      <TableQuotes
        data={dataQuotes}
        loading={loadingTable}
        reload={setReload}
        userPoints={userPoints}
      />
    </PageStructure>
  );
}
